import type { FaireOrderEntity } from "../../entity_types/order";

export const _89UGS8Z289: FaireOrderEntity = {
  token: "89UGS8Z289",
  type: "order",
  orderNumber: "#89UGS8Z289",
  status: "fulfilled",
  totalDollars: 253,
  customerName: "Elm & Ivy Gift Shop",
  firstOrder: false,
  placedAt: "Nov 27, 2025",
  shipBy: "Sep 3, 2025",
  sourceLabel: "Faire Direct",
  payoutDate: "Nov 30, 2025",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
